import React from 'react';
import PropTypes from 'prop-types';
import cx from '@/utils/cx';
import useStyle from './style';

const weightMap = {
  xs: 'regular',
  sm: 'regular',
  md: 'bold',
  lg: 'bold',
  xl: 'bold',
};

const ButtonBase = ({
  className,
  children,
  _size,
  fixedWidth,
  fullWidth,
  disabled,
  ...rest
}) => {
  const classes = useStyle({ _size, fixedWidth, fullWidth });
  return (
    <button
      type="button"
      {...(disabled ? { disabled: true } : {})}
      _text_weight={weightMap[_size]}
      _size={_size}
      className={cx(
        classes.buttonBase,
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
};


ButtonBase.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  _size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  fixedWidth: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

ButtonBase.defaultProps = {
  className: '',
  disabled: false,
  fixedWidth: false,
  fullWidth: false,
  _size: 'md',
};

export default ButtonBase;
